angular.module 'zc.core'

.controller 'PrivacyPolicyCtrl', ($rootScope, $scope, $translate, Page) ->
  Page.setBodyClass ''

  $translate('usersPages.views.privacyPolicy.title').then (translation) ->
    Page.setTitle translation

  deregistrationCallback = $rootScope.$on('languageSelected', (_, language) ->
    if language.id
      $scope.currentLang = language.id
    else
      $scope.currentLang = language
  )

  $rootScope.$on '$destroy', deregistrationCallback
  $rootScope.$emit 'selectDefaultLanguage'



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/views/privacy_policy.js.controller.coffee